import { render } from "./Profile.vue?vue&type=template&id=548f3bde"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=548f3bde&lang=scss"
script.render = render

export default script